module.exports = __webpack_public_path__ + "static/media/clubhouse-kids.87066688.mov";